import { Link } from 'react-router-dom'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company */}
          <div>
            <h3 className="text-h3 font-semibold mb-4 text-gray-900">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/beta-signup"
                  className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors"
                >
                  Join Beta
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-h3 font-semibold mb-4 text-gray-900">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors"
                  aria-label="Privacy Policy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors"
                  aria-label="Terms of Service"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-h3 font-semibold mb-4 text-gray-900">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:talktoastapp@gmail.com"
                  className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors"
                  aria-label="Email TalkToast"
                >
                  talktoastapp@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-200 text-center">
          <p className="text-body-sm text-gray-500">
            &copy; {currentYear} TalkToast. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
